// 3rd party libraries
import { motion } from 'framer-motion'
// Types
import { ButtonType, Memory, ScrapedFunerals } from '../../../types/types'
// Styles
import s from './ImgLeftCard.module.scss'
import c from 'classnames'
// Components
import { Button } from '../../core/button/Button'
import { ButtonMap } from '../../components/buttonMap/ButtonMap'
import { Image } from '../../core/image/Image'
import { Text } from '../../core/text/Text'
import NextLink from 'next/link'

type MemoryProps = {
    memory: Memory | ScrapedFunerals
    page: 'account' | 'funeral'
    buttons?: Array<ButtonType>
    funeralInfo?: string
    infoText?: string
    isScraped?: boolean
}

export default function ImgLeftCard({
    memory,
    page,
    buttons,
    infoText,
    funeralInfo,
    isScraped,
}: MemoryProps) {
    const item = {
        hidden: { opacity: 0 },
        show: { opacity: 1 },
    }

    const clickCreateBtn = () => {
        if (isScraped) {
            const btn = document.getElementById(memory.fullName)
            btn.click()
        }
    }

    const renderImage = () => {
        if (page === 'funeral' && !isScraped) {
            return (
                <NextLink
                    href={
                        buttons && Array.isArray(buttons) && !isScraped
                            ? buttons[0].to
                            : ''
                    }
                >
                    <Image
                        className={c(s.card__image, s.image_hover)}
                        centerFace
                        src={memory.profileImg}
                        alt=""
                    />
                </NextLink>
            )
        } else {
            return (
                <div className={s.image_hover} onClick={clickCreateBtn}>
                    <Image
                        className={s.card__image}
                        centerFace
                        src={memory.profileImg}
                        alt=""
                    />
                </div>
            )
        }
    }

    const renderCardInfo = () => (
        <div
            className={page === 'funeral' ? s.card__text : ''}
            onClick={clickCreateBtn}
        >
            <Text variant="h4">{memory.fullName}</Text>
            {page === 'funeral' && <Text variant="date">{funeralInfo}</Text>}
            <Text variant="date">{infoText}</Text>
            {isScraped && (
                <Text variant="p-small" className={s.card__details__scrapeText}>
                    {(memory as ScrapedFunerals).scrapeInfo}
                </Text>
            )}
        </div>
    )

    return (
        <motion.div className={c(s.card, s.noBorder)} variants={item}>
            {renderImage()}
            <div className={s.card__details}>
                {page === 'funeral' && !isScraped && (
                    <NextLink
                        href={
                            buttons && Array.isArray(buttons) && !isScraped
                                ? buttons[0].to
                                : ''
                        }
                    >
                        {renderCardInfo()}
                    </NextLink>
                )}
                {isScraped && renderCardInfo()}
                <ButtonMap className={s.card__details__buttons}>
                    {buttons.map((b, i) => (
                        <Button variant="text" type="button" key={i} {...b} />
                    ))}
                </ButtonMap>
            </div>
        </motion.div>
    )
}
